export default __webpack_public_path__ + "static/media/CLIPSREEL (Default) .ec553bf4.png";